export const getEmailLink = ({ email, subject }) => {
    return `mailto:${email}?subject=${encodeURIComponent(subject)}`;
};
